<template>
  <div style="background-color: #f5f6fa; height: 100%">
    <hear></hear>
    <BDhear :num="4"></BDhear>
    <div class="main zil casxinda xmain">
      <el-row style="display: flex; justify-content: center" :gutter="15">
        <!-- 投标保函 -->

        <!-- 履约保函 -->
        <div style="width: 90%" v-if="nametype == '履约保函'">
          <!-- {{ly_content}} -->
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; align-items: center; margin-left: 20px"
                >
                  <div class="qiu" style="">1</div>
                  <div class="qiutxt" style="">项目信息</div>
                </div>
              </template>
              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="ly_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <el-col :span="24">
                      <el-form-item label="保函编号" prop="basdasd">
                        <el-input
                          v-model="ly_content.basdasd"
                          disabled
                          placeholder="请输入保函编号"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工程名称" prop="htbh">
                        <el-input
                          v-model="ly_content.htbh"
                          @focus="tanchuang"
                          placeholder="请输入工程名称"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主(受益人)" prop="syr">
                        <el-input
                          v-model="ly_content.syr"
                          placeholder="请输入业主(受益人)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主企业性质" prop="syr">
                        <el-radio-group v-model="yzradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商(申请单位)" prop="bbzr">
                        <el-input
                          v-model="ly_content.bbzr"
                          placeholder="请输入承包商(申请单位)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商企业性质" prop="syr">
                        <el-radio-group v-model="chradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="合同造价(中标价、合同价) "
                        prop="bhje"
                      >
                        <el-input
                          type="number​"
                          v-model="ly_content.bhje"
                          placeholder="请输入合同造价(中标价、合同价) "
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开工日期" prop="startTime">
                        <el-date-picker
                          @change="lykai"
                          v-model="ly_content.startTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择开工日期"
                          clearable
                        >
                          <!-- value-format="timestamp" -->
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="竣工日期" prop="endTime">
                        <el-date-picker
                          @change="lyjei"
                          v-model="ly_content.endTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择竣工日期"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工期(天)" prop="dbqx">
                        <el-input
                          v-model="ly_content.dbqx"
                          placeholder="请输入工期(天)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保起始日期" prop="dbstartTime">
                        <el-date-picker
                          v-model="ly_content.dbstartTime"
                          @change="lykaidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保起始日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保截止日期" prop="dbendTime">
                        <el-date-picker
                          v-model="ly_content.dbendTime"
                          @change="lyjeidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保截止日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="担保期(月)" prop="dbqx">
                        <el-input
                          v-model="ly_content.dbyue"
                          placeholder="请输入担保期(月)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">月</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="合同签订时间" prop="field118">
                        <el-date-picker
                          v-model="ly_content.field118"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择合同签订时间"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="出函日期" prop="field119">
                        <el-date-picker
                          v-model="ly_content.field119"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择出函日期"
                          clearable
                        ></el-date-picker>
                        <span style="color: #e16969">
                          注:默认是担保期起始日期
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; margin-left: 20px; align-items: center"
                >
                  <div class="qiu" style="">2</div>
                  <div class="qiutxt" style="">履约保函信息</div>
                </div>
              </template>
              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="ly_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <!-- <el-col :span="24">
                  <el-form-item label="履约保函名称" prop="dbqx">
                    <el-input
                      disabled
                      v-model="ly_content.dbqx"
                      placeholder="履约保函名称"
                      clearable
                      :style="{ width: '100%' }"
                    >
                    </el-input>
                  </el-form-item>
                </el-col> -->

                    <el-col :span="24">
                      <el-form-item label="担保金额(元)" prop="dbje">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                  <div>合同造价 (中标价、合同价)</div>
                  <div>反担保金额</div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">
                                合同造价 (中标价、合同价)
                              </div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="ly_content.bhje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">保证金占比</div>
                              <el-radio-group @change="lyxuan" v-model="radio">
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                @focus="radio = 5"
                                @blur="lyxuan5"
                                v-model="ly_content.lyxuan5"
                                class="hxxin"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                type="text"
                                v-model="ly_content.dbje"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />元
                            </div>
                          </div>
                        </div>
                        <div style="color: #e16969" class="flexs">
                          注: 可根据具体情况信息填写担保金额。
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="反担保金额(元)" prop="field117">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="ly_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">
                                反担保保证金占比
                              </div>
                              <el-radio-group @change="lyfan" v-model="lyfans">
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                class="hxxin"
                                @focus="lyfans = 5"
                                @blur="lyfan5"
                                v-model="ly_content.lyfan5"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">反担保金额</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="ly_content.fdbbzj"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注: 解保或者担保截止日期满，反担保保证金原账户退回。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="保费" prop="field118">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                 
                  <div>
                    
                   
                  </div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div>担保金额</div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="buke hong"
                                disabled
                                v-model="ly_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              %
                            </div>
                            <div>
                              <div>保费月费率(千分)</div>
                              <el-radio-group @change="lybao" v-model="lybaos">
                                <el-radio :label="3">1‰</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <input
                                @focus="lybaos = 5"
                                @blur="lybaos5"
                                v-model="ly_content.lybaos5"
                                type="number"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />‰
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">担保期</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="hxxin"
                                disabled
                                v-model="ly_content.dbyue"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div>保费</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="ly_content.bfje"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注:最低收费2000,不满足最低收费按最低收费取费。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="信用反担保人" prop="startTime">
                        <el-input
                          v-model="ly_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="电话" prop="endTime">
                        <el-input
                          v-model="ly_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 业主保函 -->
        <div style="width: 90%" v-if="nametype == '业主支付保函'">
          <!-- {{ly_content}} -->
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; align-items: center; margin-left: 20px"
                >
                  <div class="qiu" style="">1</div>
                  <div class="qiutxt" style="">项目信息</div>
                </div>
              </template>
              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    style="background: #fff"
                    :model="yz_content"
                    size="medium"
                    label-width="200px"
                    label-position="left"
                  >
                    <el-col :span="24">
                      <el-form-item label="保函编号" prop="basdasd">
                        <el-input
                          v-model="yz_content.basdasd"
                          disabled
                          placeholder="请输入保函编号"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工程名称" prop="htbh">
                        <el-input
                          v-model="ly_content.htbh"
                          @focus="tanchuang"
                          placeholder="请输入工程名称"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主(申请单位)" prop="syr">
                        <el-input
                          v-model="yz_content.yf"
                          placeholder="请输入业主(申请单位)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主企业性质" prop="syr">
                        <el-radio-group v-model="yzradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商(受益人)" prop="bbzr">
                        <el-input
                          v-model="yz_content.jf"
                          placeholder="请输入承包商(受益人)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商企业性质" prop="syr">
                        <el-radio-group v-model="chradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="合同造价(中标价、合同价) "
                        prop="bhje"
                      >
                        <el-input
                          type="number​"
                          v-model="yz_content.bhje"
                          placeholder="请输入合同造价(中标价、合同价) "
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="合同编号" prop="bhje">
                        <el-input
                          type="number​"
                          v-model="yz_content.htbhs"
                          placeholder="请输入合同编号"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <!-- <template slot="append">元</template> -->
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开工日期" prop="startTime">
                        <el-date-picker
                          @change="yzkai"
                          v-model="yz_content.startTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择开工日期"
                          clearable
                        >
                          <!-- value-format="timestamp" -->
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="竣工日期" prop="endTime">
                        <el-date-picker
                          @change="yzjei"
                          v-model="yz_content.endTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择竣工日期"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工期(天)" prop="dbqx">
                        <el-input
                          disabled
                          v-model="yz_content.dbqx"
                          placeholder="请输入工期(天)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保起始日期" prop="dbstartTime">
                        <el-date-picker
                          v-model="yz_content.dbstartTime"
                          @change="yzkaidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保起始日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保截止日期" prop="dbendTime">
                        <el-date-picker
                          v-model="yz_content.dbendTime"
                          @change="yzjeidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保截止日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="担保期(月)" prop="dbqx">
                        <el-input
                          v-model="yz_content.dbyue"
                          placeholder="请输入担保期(月)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">月</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="合同签订时间" prop="field118">
                        <el-date-picker
                          v-model="yz_content.htqd"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择合同签订时间"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="出函日期" prop="field119">
                        <el-date-picker
                          v-model="yz_content.field119"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择出函日期"
                          clearable
                        ></el-date-picker>
                        <span style="color: #e16969">
                          注:默认是担保期起始日期
                        </span>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                  <el-form-item label="保函费率" prop="dbqx">
                    <el-input
                    disabled
                v-model="yz_content.fl"
                      clearable
                      :style="{ width: '100%' }"
                    >
                  
                    </el-input>
                  </el-form-item>
                </el-col> -->
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>

            <el-collapse-item name="2" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; margin-left: 20px; align-items: center"
                >
                  <div class="qiu" style="">2</div>
                  <div class="qiutxt" style="">业主工程款支付保函信息</div>
                </div>
              </template>

              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="ly_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <!-- <el-col :span="24">
                  <el-form-item label="业主工程款支付保函名称" prop="dbqx">
                    <el-input
                      disabled
                      v-model="ly_content.dbqx"
                      placeholder="业主工程款支付保函名称"
                      clearable
                      :style="{ width: '100%' }"
                    >
                    </el-input>
                  </el-form-item>
                </el-col> -->

                    <el-col :span="24">
                      <el-form-item label="担保金额(元)" prop="dbje">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                  <div>合同造价 (中标价、合同价)</div>
                  <div>反担保金额</div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">
                                合同造价 (中标价、合同价)
                              </div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="yz_content.bhje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">保证金占比</div>
                              <el-radio-group
                                @change="yzxuan"
                                v-model="yzradio"
                              >
                                <el-radio :label="3">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                @focus="yzradio = 5"
                                @blur="yzxuan5"
                                v-model="yz_content.lyxuan5"
                                class="hxxin"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">
                                <i style="color: #ff2f1f">*</i> 担保金额
                              </div>
                              <input
                                class="hxxin hong"
                                type="text"
                                v-model="yz_content.dbje"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />元
                            </div>
                          </div>
                        </div>
                        <div style="color: #e16969" class="flexs">
                          注: 可根据具体情况信息填写担保金额。
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="反担保金额(元)" prop="field117">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="yz_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">
                                反担保保证金占比
                              </div>
                              <el-radio-group @change="yzfan" v-model="yzfans">
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                class="hxxin"
                                @focus="yzfans = 5"
                                @blur="yzfan5"
                                v-model="yz_content.lyfan5"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">
                                <i style="color: #ff2f1f">*</i>反担保金额
                              </div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="yz_content.fdbbzj"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注: 解保或者担保截止日期满，反担保保证金原账户退回。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="保费" prop="field118">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                 
                  <div>
                    
                   
                  </div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div>担保金额</div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="buke hong"
                                disabled
                                v-model="yz_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              %
                            </div>
                            <div>
                              <div>月费率(千分)</div>
                              <el-radio-group @change="yzbao" v-model="yzbaos">
                                <el-radio :label="3">2.5‰</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <input
                                @focus="yzbaos = 5"
                                @blur="yzbaos5"
                                v-model="yz_content.lybaos5"
                                type="number"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />‰
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">担保期</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="hxxin"
                                disabled
                                v-model="yz_content.dbyue"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div><i style="color: #ff2f1f">*</i>保费</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="yz_content.bfje"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注:最低收费2000,不满足最低收费按最低收费取费。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="信用反担保人" prop="startTime">
                        <el-input
                          v-model="yz_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="电话" prop="endTime">
                        <el-input
                          v-model="yz_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 农民工工资支付保函 -->
        <div style="width: 90%" v-if="nametype == '农民工工资支付保函'">
          <!-- {{ly_content}} -->
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; align-items: center; margin-left: 20px"
                >
                  <div class="qiu" style="">1</div>
                  <div class="qiutxt" style="">项目信息</div>
                </div>
              </template>
              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="nm_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <el-col :span="24">
                      <el-form-item label="保函编号" prop="basdasd">
                        <el-input
                          v-model="nm_content.basdasd"
                          disabled
                          placeholder="请输入保函编号"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工程名称" prop="htbh">
                        <el-input
                          v-model="nm_content.gcxm"
                          @focus="tanchuang"
                          placeholder="请输入工程名称"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主(受益人)" prop="syr">
                        <el-input
                          v-model="nm_content.syr"
                          placeholder="请输入业主(受益人)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主企业性质" prop="syr">
                        <el-radio-group v-model="yzradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商(申请单位)" prop="bbzr">
                        <el-input
                          v-model="nm_content.bbzr"
                          placeholder="请输入承包商(申请单位)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商企业性质" prop="syr">
                        <el-radio-group v-model="chradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="合同造价(中标价、合同价) "
                        prop="bhje"
                      >
                        <el-input
                          type="number​"
                          v-model="nm_content.bhje"
                          placeholder="请输入合同造价(中标价、合同价) "
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开工日期" prop="startTime">
                        <el-date-picker
                          @change="nmkai"
                          v-model="nm_content.gqStartTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择开工日期"
                          clearable
                        >
                          <!-- value-format="timestamp" -->
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="竣工日期" prop="endTime">
                        <el-date-picker
                          @change="nmjei"
                          v-model="nm_content.gqEndTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择竣工日期"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工期(天)" prop="dbqx">
                        <el-input
                          v-model="nm_content.dbqx"
                          placeholder="请输入工期(天)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="竣工后/天" prop="dbqx">
                        <el-input
                          v-model="nm_content.day"
                          placeholder="请输入竣工后/天"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="项目地址" prop="dbqx">
                        <el-input
                          v-model="nm_content.xmdz"
                          placeholder="请输入项目地址"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <!-- <template slot="append">天</template> -->
                        </el-input>
                      </el-form-item>
                      <el-form-item label="建筑面积" prop="dbqx">
                        <el-input
                          v-model="nm_content.jzmj"
                          placeholder="请输入建筑面积"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <!-- <template slot="append">天</template> -->
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保起始日期" prop="dbstartTime">
                        <el-date-picker
                          v-model="nm_content.bzqStartTime"
                          @change="nmkaidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保起始日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保截止日期" prop="dbendTime">
                        <el-date-picker
                          v-model="nm_content.bzqEndTime"
                          @change="nmjeidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保截止日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="担保期(月)" prop="dbqx">
                        <el-input
                          v-model="nm_content.dbyue"
                          placeholder="请输入担保期(月)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">月</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="合同签订时间" prop="field118">
                        <el-date-picker
                          v-model="nm_content.qdsj"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择合同签订时间"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="出函日期" prop="field119">
                        <el-date-picker
                          v-model="nm_content.field119"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择出函日期"
                          clearable
                        ></el-date-picker>
                        <span style="color: #e16969">
                          注:默认是担保期起始日期
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>

            <el-collapse-item name="2" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; margin-left: 20px; align-items: center"
                >
                  <div class="qiu" style="">2</div>
                  <div class="qiutxt" style="">农名工工资支付保函信息</div>
                </div>
              </template>

              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="nm_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <!-- <el-col :span="24">
                      <el-form-item label="农名工工资支付保函名称" prop="dbqx">
                        <el-input
                          disabled
                          v-model="nm_content.dbqx"
                          placeholder="农名工工资支付保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col> -->

                    <el-col :span="24">
                      <el-form-item label="担保金额(元)" prop="dbje">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                  <div>合同造价 (中标价、合同价)</div>
                  <div>反担保金额</div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">
                                合同造价 (中标价、合同价)
                              </div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="nm_content.bhje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">保证金占比</div>
                              <el-radio-group
                                @change="nmxuan"
                                v-model="nmradio"
                              >
                                <el-radio :label="3">2%</el-radio>
                                <!-- <el-radio :label="6">5%</el-radio>
                            <el-radio :label="9">10%</el-radio> -->
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                @focus="nmradio = 5"
                                @blur="nmxuan5"
                                v-model="nm_content.lyxuan5"
                                class="hxxin"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                type="text"
                                v-model="nm_content.dbje"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />元
                            </div>
                          </div>
                        </div>
                        <div style="color: #e16969" class="flexs">
                          注: 可根据具体情况信息填写担保金额。
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="反担保金额(元)" prop="field117">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="nm_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <el-radio-group @change="nmfan" v-model="nmfans">
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                class="hxxin"
                                @focus="nmfans = 5"
                                @blur="nmfan5"
                                v-model="nm_content.lyfan5"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">反担保金额</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="nm_content.fdbbzj"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注: 解保或者担保截止日期满，反担保保证金原账户退回。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="保费" prop="field118">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                 
                  <div>
                    
                   
                  </div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div>担保金额</div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="buke hong"
                                disabled
                                v-model="nm_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              %
                            </div>
                            <div>
                              <div>保费月费率(千分)</div>
                              <el-radio-group @change="nmbao" v-model="nmbaos">
                                <el-radio :label="3">2‰</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <input
                                @focus="nmbaos = 5"
                                @blur="nmbaos5"
                                v-model="nm_content.lybaos5"
                                type="number"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />‰
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">担保期</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="hxxin"
                                disabled
                                v-model="nm_content.dbyue"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div>保费</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="nm_content.bfje"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注:最低收费2000,不满足最低收费按最低收费取费。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="信用反担保人" prop="startTime">
                        <el-input
                          v-model="nm_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="电话" prop="endTime">
                        <el-input
                          v-model="nm_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 质量保函 -->
        <div style="width: 90%" v-if="nametype == '质量保函'">
          <!-- {{ly_content}} -->
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1" style="border-bottom: 2px solid #f5f6fa">
              <template slot="title">
                <div
                  style="display: flex; align-items: center; margin-left: 20px"
                >
                  <div class="qiu" style="">1</div>
                  <div class="qiutxt" style="">项目信息</div>
                </div>
              </template>
              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="zl_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <el-col :span="24">
                      <el-form-item label="保函编号" prop="basdasd">
                        <el-input
                          v-model="zl_content.basdasd"
                          disabled
                          placeholder="请输入保函编号"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工程名称" prop="htbh">
                        <el-input
                          v-model="zl_content.htbh"
                          @focus="tanchuang"
                          placeholder="请输入工程名称"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主(受益人)" prop="syr">
                        <el-input
                          v-model="zl_content.syr"
                          placeholder="请输入业主(受益人)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="业主企业性质" prop="syr">
                        <el-radio-group v-model="yzradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商(申请单位)" prop="bbzr">
                        <el-input
                          v-model="zl_content.bbzr"
                          placeholder="请输入承包商(申请单位)"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="承包商企业性质" prop="syr">
                        <el-radio-group v-model="chradio">
                          <el-radio :label="1">政府</el-radio>
                          <el-radio :label="2">事业单位</el-radio>
                          <el-radio :label="3">国有企业</el-radio>
                          <el-radio :label="4">特级资质的建筑企业</el-radio>
                          <el-radio :label="5"
                            >获得过鲁班奖的一级建筑企业</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="合同造价(中标价、合同价) "
                        prop="bhje"
                      >
                        <el-input
                          type="number​"
                          v-model="zl_content.bhje"
                          placeholder="请输入合同造价(中标价、合同价) "
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开工日期" prop="startTime">
                        <el-date-picker
                          @change="zlkai"
                          v-model="zl_content.startTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择开工日期"
                          clearable
                        >
                          <!-- value-format="timestamp" -->
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="竣工日期" prop="endTime">
                        <el-date-picker
                          @change="zljei"
                          v-model="zl_content.endTime"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择竣工日期"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="工期(天)" prop="dbqx">
                        <el-input
                          v-model="zl_content.dbqx"
                          placeholder="请输入工期(天)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保起始日期" prop="dbstartTime">
                        <el-date-picker
                          v-model="zl_content.dbstartTime"
                          @change="zlkaidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保起始日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="担保截止日期" prop="dbendTime">
                        <el-date-picker
                          v-model="zl_content.dbendTime"
                          @change="zljeidb"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择担保截止日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="担保期(月)" prop="dbqx">
                        <el-input
                          v-model="zl_content.dbyue"
                          placeholder="请输入担保期(月)"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <template slot="append">月</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="合同签订时间" prop="field118">
                        <el-date-picker
                          v-model="zl_content.field118"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择合同签订时间"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="出函日期" prop="field119">
                        <el-date-picker
                          v-model="zl_content.field119"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }"
                          placeholder="请选择出函日期"
                          clearable
                        ></el-date-picker>
                        <span style="color: #e16969">
                          注:默认是担保期起始日期
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
                       
            </el-collapse-item>

                   <el-collapse-item
              name="2"
              style="border-bottom: 2px solid #f5f6fa"
            >
                       
              <template slot="title">
                         
                <div
                  style="display: flex; margin-left: 20px; align-items: center"
                >
                             
                  <div class="qiu" style="">2</div>
                             
                  <div class="qiutxt" style="">质量保证保函信息</div>
                           
                </div>
                         
              </template>
                 

              <div style="background: #fff; padding: 3%">
                <el-row :gutter="14">
                  <el-form
                    ref="elForm"
                    style="background: #fff"
                    :model="zl_content"
                
                    size="medium"
                    label-width="180px"
                    label-position="left"
                  >
                    <el-col :span="24">
                      <el-form-item label="质量保证保函名称" prop="dbqx">
                        <el-input
                          disabled
                          v-model="zl_content.dbqx"
                          placeholder="质量保证保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item label="担保金额(元)" prop="dbje">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                  <div>合同造价 (中标价、合同价)</div>
                  <div>反担保金额</div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">
                                合同造价 (中标价、合同价)
                              </div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="zl_content.bhje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">保证金占比</div>
                              <el-radio-group
                                @change="zlxuan"
                                v-model="zlradio"
                              >
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                @focus="zlradio = 5"
                                @blur="zlxuan5"
                                v-model="zl_content.lyxuan5"
                                class="hxxin"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                type="text"
                                v-model="zl_content.dbje"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />元
                            </div>
                          </div>
                        </div>
                        <div style="color: #e16969" class="flexs">
                          注: 可根据具体情况信息填写担保金额。
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="反担保金额(元)" prop="field117">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div style="text-align: center">担保金额</div>
                              <input
                                class="hxxin hong"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100%;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                  text-align: center;
                                "
                                v-model="zl_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">
                                反担保保证金占比
                              </div>
                              <el-radio-group @change="zlfan" v-model="zlfans">
                                <el-radio :label="3">3%</el-radio>
                                <el-radio :label="6">5%</el-radio>
                                <el-radio :label="9">10%</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              <input
                                class="hxxin"
                                @focus="zlfans = 5"
                                @blur="zlfan5"
                                v-model="zl_content.lyfan5"
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 100px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />%
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div style="text-align: center">反担保金额</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="zl_content.fdbbzj"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注: 解保或者担保截止日期满，反担保保证金原账户退回。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="保费" prop="field118">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                          "
                        >
                          <!-- <div style="justify-content: space-between" class="flexs">
                 
                  <div>
                    
                   
                  </div>
                </div> -->
                          <div
                            style="justify-content: space-around"
                            class="flexs"
                          >
                            <div>
                              <div>担保金额</div>
                              <input
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="buke hong"
                                disabled
                                v-model="zl_content.dbje"
                                type="text"
                              />
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              %
                            </div>
                            <div>
                              <div>保费月费率(千分)</div>
                              <el-radio-group @change="zlbao" v-model="zlbaos">
                                <el-radio :label="3">2‰</el-radio>
                                <el-radio :label="5">其他</el-radio>
                              </el-radio-group>
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <input
                                @focus="zlbaos = 5"
                                @blur="zlbaos5"
                                v-model="zl_content.lybaos5"
                                type="number"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                              />‰
                            </div>
                            <div>
                              <div>&nbsp;</div>
                              <i class="el-icon-close"></i>
                            </div>
                            <div>
                              <div style="text-align: center">担保期</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                class="hxxin"
                                disabled
                                v-model="zl_content.dbyue"
                              />
                            </div>
                            <div>
                              <div style="text-align: center">&nbsp;</div>
                              =
                            </div>
                            <div>
                              <div>保费</div>
                              <input
                                type="text"
                                style="
                                  height: 24px;
                                  padding: 0;
                                  width: 70px;
                                  font-size: 18px;
                                  border-bottom: 2px solid;
                                "
                                v-model="zl_content.bfje"
                              />元
                            </div>
                          </div>
                          <div style="color: #e16969" class="flexs">
                            注:最低收费2000,不满足最低收费按最低收费取费。
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="信用反担保人" prop="startTime">
                        <el-input
                          v-model="zl_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col v-if="fandanb" :span="12">
                      <el-form-item label="电话" prop="endTime">
                        <el-input
                          v-model="zl_content.dbqx"
                          placeholder="履约保函名称"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
                     </el-collapse-item
            >
          </el-collapse>
        </div>
      </el-row>
    </div>

    <div class="footer">
      <el-button @click="Submittals" style="width: 175px; height: 60px"
        >上一步</el-button
      >
      <el-button
        @click="Signature"
        style="width: 175px; height: 60px"
        type="primary"
        >下一步</el-button
      >
      <!-- <el-button v-if="this.nametype !== '投标保函'" @click="Signature" style="width: 175px; height: 60px" type="primary">下一步</el-button> -->
      <!-- <el-button v-else   @click="tiao()" style="width: 175px; height: 60px" type="primary">提交审核</el-button>
        <el-button v-if="!isShow" @click="$router.push('/')" style="width: 175px; height: 60px" type="primary">回到首页</el-button>
       <el-button   v-if="isShow1" style="width: 175px; height: 60px" type="info" disabled>审核中</el-button>
         <el-button v-if="isShow2" @click="$router.push('/Bidpayments')" style="width: 175px; height: 60px"  type="primary" disabled="">审核已完成，去支付</el-button> -->
    </div>
  </div>
</template>

<script>
import BDhear from "./BDhear.vue";
import hear from ".././../components/hear.vue";
import { bidfrom } from "@/api/system/liucheng";
import { bhdetail, shebaolist } from "@/api/system/liucheng";
import axios from "axios";
export default {
  components: {
    BDhear,
    hear,
  },
  props: [],
  statis: false,
  name: "bidFrom",
  data() {
    return {
      //投标保函 {"bhje":1477.44,"sqr":"1233","syr":"12312","zbr":"3123","tbr":"123123","xmmc":"1231","xmbh":"23123","bzjje":"123","startTime":"2022-10-28","endTime":"2022-11-09","dbqx":"12","bfje":212751.36,"fl":"12"}

      //业主支付保函 {"yf":"123","jf":"123","htqd":"2022-09-28","htbh":"123123","bhje":12.3,"startTime":"2022-09-28","endTime":"2022-10-10","dbqx":"12","bfje":18172954.800000004,"fl":"123123","fdbbzj":"12","dbje":12.3,"zfje":12.3}
      //农名工工资支付保函 {"syr":"12312","bbzr":"123123","gcxm":"123123","qdsj":"2022-09-28","xmdz":"123123","jzmj":"123123","gczj":"1231231","bhje":283.13,"xmdzdbbz":"123123","gqStartTime":"2022-09-28","gqEndTime":"2022-10-10","day":"123","bzqStartTime":"2022-09-28","bzqEndTime":"2022-10-10","dbqx":"10","bfje":28313,"fl":"10","fdbbzj":""}
      //质量保函 {"syr":"","bbzr":"2312","htbh":"12312","bhje":151.29,"endTime":"2026-01-22","dbqx":"1212","bfje":22576261748.039997,"fl":"123123","fdbbzj":"123123","startTime":"2022-09-28"}

      // 质量保函
      zl_content: {
        basdasd: sessionStorage.getItem("apply_number"),
        syr: sessionStorage.getItem("purchase_person_name"),
        bbzr: sessionStorage.getItem("cardname"),
        htbh: sessionStorage.getItem("bidding_project_name"),
        bhje: null,
        endTime: null,
        dbqx: null,
        bfje: null,
        fl: sessionStorage.getItem("guarantee_company_rate"),
        fdbbzj: null,
        startTime: null,
        dbendTime: null,
        startTime: null,
        field116: null,
        field115: null,
        field118: null,
        field119: null,
        dbstartTime: null,
        dbyue: null,
        lybaos5: null,
        lyfan5: null,
        lyxuan5: null,
        // xma_mobile:sessionStorage.getItem("xma_mobile")
      },
      fandanb: false,
      activeNames: ["1"],
      zlradio: 0,
      zlfans: 0,
      zlbaos: 0,
      zldbqt: null,
      zlfdbqt: null,
      zlbfqtLnull: null,
      // 投标保函
      isShow: false,
      isShow1: false,
      isShow2: false,
      falasdse: false,

      content: {
        bhje: 100,
        sqr: "",
        syr: "",
        zbr: "",
        tbr: "",
        xmmc: "",
        xmbh: "",
        bzjje: "1",
        startTime: null,
        endTime: null,
        dbqx: "",
        bfje: null,
        fl: "",
      },
      rulses: {
        field102: [
          {
            required: true,
            message: "请输入保函编号",
            trigger: "blur",
          },
        ],
        field110: [
          {
            required: true,
            message: "请输入项目编号",
            trigger: "blur",
          },
        ],
        field103: [
          {
            required: true,
            message: "请输入保函金额",
            trigger: "blur",
          },
        ],
        field111: [
          {
            required: true,
            message: "请输入保证金额",
            trigger: "blur",
          },
        ],
      },
      cion: {
        id: "",
      },
      shijian: false,
      nametype: "",
      // 履约保函相关上
      //履约保函 {"syr":null,"bbzr":null,"htbh":null,"dbje":null,"bhje":null,"endTime":null,"dbqx":null,"bfje":null,"fl":null,"fdbbzj":null,"startTime":null}
      ly_content: {
        basdasd: sessionStorage.getItem("apply_number"),
        syr: sessionStorage.getItem("purchase_person_name"),
        bbzr: sessionStorage.getItem("cardname"),
        htbh: sessionStorage.getItem("bidding_project_name"),
        dbje: null,
        bhje: null,
        bhbh: sessionStorage.getItem("apply_number"),
        endTime: null,
        dbqx: null,
        bfje: null,
        fl: sessionStorage.getItem("guarantee_company_rate"),
        // xma_mobile:sessionStorage.getItem("xma_mobile"),
        fdbbzj: null,
        startTime: null,
        field116: null,
        field115: null,
        field118: null,
        field119: null,
        dbstartTime: null,
        dbyue: null,
        lybaos5: null,
        lyfan5: null,
        lyxuan5: null,
      },
      zgdbje: false,
      value1: "",
      radio: 0,
      lyfans: 0,
      lybaos: 0,
      lydbqt: null,
      lyfdbqt: null,
      lybfqtLnull: null,
      nmradio: 0,
      // 履约保函相关下
      // 业主支付保函
      yz_content: {
        // xma_mobile:sessionStorage.getItem("xma_mobile"),
        basdasd: sessionStorage.getItem("apply_number"),
        yf: sessionStorage.getItem("cardname"),
        syr: sessionStorage.getItem("cardname"),
        jf: sessionStorage.getItem("purchase_person_name"),
        htqd: "",
        htbh: sessionStorage.getItem("bidding_project_name"),
        bhje: null,
        startTime: null, //开始时间
        endTime: null,
        dbqx: "",
        bfje: null,
        fl: sessionStorage.getItem("guarantee_company_rate"),
        fdbbzj: null,
        dbje: null,
        zfje: null,
        field116: null,
        field115: null,
        field118: null,
        field119: null,
        dbstartTime: null,
        dbyue: null,
        lybaos5: null,
        lyfan5: null,
        lyxuan5: null,
      },
      yzradio: 0,
      yzfans: 0,
      yzbaos: 0,
      yzdbqt: null,
      yzfdbqt: null,
      yzbfqtLnull: null,
      // 业主支付保函
      // 农民工工资支付保函
      nm_content: {
        // xma_mobile:sessionStorage.getItem("xma_mobile"),
        basdasd: sessionStorage.getItem("apply_number"),
        syr: "",
        bbzr: sessionStorage.getItem("cardname"),
        gcxm: sessionStorage.getItem("bidding_project_name"),
        qdsj: "",
        //添加
        // bhje:"",
        // bfje:"",
        //  添加
        xmdz: "",
        jzmj: "",
        gczj: sessionStorage.getItem("margin_amount"),
        bhje: null,
        xmdzdbbz: "",
        gqStartTime: "",
        gqEndTime: "",
        endTime: "",
        day: "",
        bzqStartTime: null,
        bzqEndTime: null,
        dbje: null,
        dbqx: "",
        bfje: null,
        fl: sessionStorage.getItem("guarantee_company_rate"),
        fdbbzj: "",
        field116: null,
        field115: null,
        field118: null,
        field119: null,
        dbstartTime: null,
        dbyue: null,
        lybaos5: null,
        lyfan5: null,
        lyxuan5: null,
      },
      zgdbje: false,
      value1: "",
      nmradio: 0,
      nmfans: 0,
      nmbaos: 0,
      nmdbqt: null,
      nmfdbqt: null,
      nmbfqtLnull: null,
      restaurants: [],
      state: "",
      timeout: null,
      // 农民工工资支付保函
      options: [
        {
          value: "选项1",
          label: "3",
        },
        {
          value: "选项2",
          label: "5",
        },
        {
          value: "选项3",
          label: "10",
        },
        {
          value: "选项4",
          label: "其他",
        },
      ],
      value: "",
      yzradio: 0,
      chradio: 0,
    };
  },
  mounted() {
    this.nametype = sessionStorage.getItem("bhlein");
    console.log(this.nametype);
    // this.restaurants = this.loadAll();
  },
  created() {
    this.content.xmbh = sessionStorage.getItem("bidding_number");
    this.content.apply_number = sessionStorage.getItem("apply_number");
    var biansd = sessionStorage.getItem("guarantee_apply_id");
    bhdetail({ apply_number: this.content.apply_number }).then((err) => {
      console.log("已经提交", err.data.data);
      var baohanjibe = err.data.data.jiben;
      this.content.bhje = baohanjibe.margin_amount;
      this.zl_content.bhje = baohanjibe.margin_amount;
      this.ly_content.bhje = baohanjibe.margin_amount;
      this.nm_content.bhje = baohanjibe.margin_amount;
      this.yz_content.bhje = baohanjibe.margin_amount;
      this.content.tbr = baohanjibe.apply_company_name;
    });
    sessionStorage.setItem("apply_number", this.content.apply_number);
    this.content.xmbh = sessionStorage.getItem("bidding_name");
    this.content.sqr = sessionStorage.getItem("cardname");
    this.content.zbr = sessionStorage.getItem("purchase_person_name");
    this.content.syr = sessionStorage.getItem("purchase_person_name");
    // this.content.xmbh = sessionStorage.getItem("bidding_number");
    this.content.xmmc = sessionStorage.getItem("bidding_project_name");
    this.content.fl = sessionStorage.getItem("guarantee_company_rate");

    this.content.startTime = this.dateFormat(
      sessionStorage.getItem("bid_begin_time")
    );
    var bbc = 60 * 3600 * 24 + Number(sessionStorage.getItem("bid_begin_time"));
    this.content.endTime = this.dateFormat(bbc);
    // console.log( this.content.endTime,bbc)
    this.cion.id = sessionStorage.getItem("guarantee_apply_id");
    // this.shijai()
  },
  methods: {
    loadAll() {
      if (this.nm_content.syr == "") {
        return;
      }
      var key = {
        keywords: this.nm_content.syr,
      };
      shebaolist(key).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data.rows);
          this.restaurants = res.data.data.rows;
          // this.restaurants=[  { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },]
        }
      });
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;

      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 2000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        console.log("chaxun", state);
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    },

    // ————————————————————————————————————————————————————————————————————————————————————————
    lyxuan(e) {
      console.log("履约保函当前选择", e, parseFloat(this.ly_content.bhje));

      if (e == 5) {
        this.ly_content.dbje =
          (parseFloat(this.ly_content.bhje) * this.ly_content.lyxuan5) / 100;
      }
      if (e == 3) {
        this.ly_content.dbje = parseFloat(this.ly_content.bhje) * 0.03;
        // this.ly_content.fdbbzj = parseFloat(this.ly_content.bhje) * 0.03 * 0.01;
        // this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
        // this.ly_content.bfje =
        //   parseFloat(this.ly_content.dbje) * this.ly_content.fl;
        // console.log(this.ly_content.dbje)
      }
      if (e == 6) {
        this.ly_content.dbje = parseFloat(this.ly_content.bhje) * 0.05;
        // this.ly_content.fdbbzj = parseFloat(this.ly_content.bhje) * 0.05 * 0.01;
        // this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
        // this.ly_content.bfje =
        //   parseFloat(this.ly_content.dbje) * this.ly_content.fl;
        // console.log(this.ly_content.dbje)
      }
      if (e == 9) {
        this.ly_content.dbje = parseFloat(this.ly_content.bhje) * 0.1;
        // this.ly_content.fdbbzj = parseFloat(this.ly_content.bhje) * 0.1 * 0.01;
        // this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
        // this.ly_content.bfje =
        //   parseFloat(this.ly_content.dbje) * this.ly_content.fl;
        // console.log(this.ly_content.dbje)
      }
    },
    lyxuan5(e) {
      this.ly_content.dbje =
        (parseFloat(this.ly_content.bhje) * this.ly_content.lyxuan5) / 100;
      // this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5 /100
      this.ly_content.dbje = this.ly_content.dbje.toFixed(2);
    },
    lyfan(e) {
      console.log("履约保函当前选择", e, parseFloat(this.ly_content.dbje));
      if (e == 3) {
        this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * 0.03;
        this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
      }
      if (e == 5) {
        this.ly_content.fdbbzj =
          (parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5) / 100;
        this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
      }
      if (e == 6) {
        this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * 0.05;
        this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
      }
      if (e == 9) {
        this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * 0.1;
        this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
      }
    },
    lyfan5() {
      this.ly_content.fdbbzj =
        (parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5) / 100;

      this.ly_content.fdbbzj = this.ly_content.fdbbzj.toFixed(2);
    },
    lybao(e) {
      if (e == 3) {
        this.ly_content.bfje =
          parseFloat(this.ly_content.dbje) * 0.001 * this.ly_content.dbyue;
        if (this.ly_content.bfje < 2000) {
          this.ly_content.bfje = 2000;
        }
        this.ly_content.bfje = this.ly_content.bfje.toFixed(2);
      }
    },
    lybaos5() {
      this.ly_content.bfje =
        ((parseFloat(this.ly_content.dbje) * this.ly_content.lybaos5) / 1000) *
        this.ly_content.dbyue;
      if (this.ly_content.bfje < 2000) {
        this.ly_content.bfje = 2000;
      }
      this.ly_content.bfje = this.ly_content.bfje.toFixed(2);
    },
    lykai(e) {
      this.ly_content.dbstartTime = this.ly_content.startTime;
      this.ly_content.field119 = this.ly_content.startTime;
      console.log(123, this.sdateFormat(e), this.ly_content.startTime);
    },
    lykaidb(e) {
      this.ly_content.field119 = this.ly_content.dbstartTime;
      this.ly_content.dbyue = this.calculateDiffTime(
        this.ly_content.dbstartTime,
        this.ly_content.dbendTime
      );
    },
    lyjeidb(e) {
      this.ly_content.dbyue = this.calculateDiffTime(
        this.ly_content.dbstartTime,
        this.ly_content.dbendTime
      );
    },
    lyjei(e) {
      //  this.calculateDiffTime();
      //  return

      console.log(this.ly_content.startTime);
      if (this.ly_content.startTime == null) {
        this.$message({
          showClose: true,
          message: "请先选择开工日期",
          type: "warning",
        });
        this.ly_content.endTime = null;
      } else {
        this.ly_content.dbendTime = this.ly_content.endTime;
        this.ly_content.dbqx = this.sdateFormats(
          this.ly_content.startTime,
          this.ly_content.endTime
        );
        this.ly_content.dbyue = this.calculateDiffTime(
          this.ly_content.startTime,
          this.ly_content.endTime
        );
        // console.log()
        // console.log()
        // var cion =
        //   Number(this.ly_content.endTime) - Number(this.ly_content.startTime);
        // // +86400000
        // console.log(
        //   "计算时间",
        //   cion,
        //   this.sdateFormat(cion),
        //   this.ly_content.endTime
        // );
        // sdateFormats(cion)
        // this.calculateDiffTime();
        // this.ly_content.dbqx = this.sdateFormat(cion);
      }
    },
    // 业主支付保函
    yzkai(e) {
      console.log(123, this.sdateFormat(e), this.yz_content.startTime);
      this.yz_content.field119 = this.yz_content.startTime;
      this.yz_content.dbstartTime = this.yz_content.startTime;
    },
    yzjei(e) {
      console.log(this.yz_content.startTime);
      if (this.yz_content.startTime == null) {
        this.$message({
          showClose: true,
          message: "请先选择开工日期",
          type: "warning",
        });
        this.yz_content.endTime = null;
      } else {
        this.yz_content.dbendTime = this.yz_content.endTime;
        this.yz_content.dbqx = this.sdateFormats(
          this.yz_content.startTime,
          this.yz_content.endTime
        );
        this.yz_content.dbyue = this.calculateDiffTime(
          this.yz_content.startTime,
          this.yz_content.endTime
        );
      }
    },
    yzkaidb(e) {
      this.yz_content.field119 = this.yz_content.dbstartTime;
      this.yz_content.dbyue = this.calculateDiffTime(
        this.yz_content.dbstartTime,
        this.yz_content.dbendTime
      );
    },
    yzjeidb(e) {
      this.yz_content.dbyue = this.calculateDiffTime(
        this.yz_content.dbstartTime,
        this.yz_content.dbendTime
      );
    },
    yzxuan(e) {
      if (e == 5) {
        this.yz_content.dbje =
          (parseFloat(this.yz_content.bhje) * this.yz_content.lyxuan5) / 100;
      }
      if (e == 3) {
        this.yz_content.dbje = parseFloat(this.yz_content.bhje) * 0.1;
      }
    },
    yzxuan5(e) {
      this.yz_content.dbje =
        (parseFloat(this.yz_content.bhje) * this.yz_content.lyxuan5) / 100;
      // this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5 /100
      this.yz_content.dbje = this.yz_content.dbje.toFixed(2);
    },
    yzfan(e) {
      if (e == 3) {
        this.yz_content.fdbbzj = parseFloat(this.yz_content.dbje) * 0.03;
        this.yz_content.fdbbzj = this.yz_content.fdbbzj.toFixed(2);
      }
      if (e == 5) {
        this.yz_content.fdbbzj =
          (parseFloat(this.yz_content.dbje) * this.yz_content.lyfan5) / 100;
        this.yz_content.fdbbzj = this.yz_content.fdbbzj.toFixed(2);
      }
      if (e == 6) {
        this.yz_content.fdbbzj = parseFloat(this.yz_content.dbje) * 0.05;
        this.yz_content.fdbbzj = this.yz_content.fdbbzj.toFixed(2);
      }
      if (e == 9) {
        this.yz_content.fdbbzj = parseFloat(this.yz_content.dbje) * 0.1;
        this.yz_content.fdbbzj = this.yz_content.fdbbzj.toFixed(2);
      }
    },
    yzfan5() {
      this.yz_content.fdbbzj =
        (parseFloat(this.yz_content.dbje) * this.yz_content.lyfan5) / 100;

      this.yz_content.fdbbzj = this.yz_content.fdbbzj.toFixed(2);
    },
    yzbao(e) {
      if (e == 3) {
        this.yz_content.bfje =
          parseFloat(this.yz_content.dbje) * 0.0025 * this.yz_content.dbyue;
        if (this.yz_content.bfje < 2000) {
          this.yz_content.bfje = 2000;
        }
        this.yz_content.bfje = this.yz_content.bfje.toFixed(2);
      }
    },
    yzbaos5() {
      this.yz_content.bfje =
        ((parseFloat(this.yz_content.dbje) * this.yz_content.lybaos5) / 1000) *
        this.yz_content.dbyue;
      if (this.yz_content.bfje < 2000) {
        this.yz_content.bfje = 2000;
      }
      this.yz_content.bfje = this.yz_content.bfje.toFixed(2);
    },

    // 质量保函
    zlkai(e) {
      // console.log(123, this.sdateFormat(e), this.yz_content.startTime);
      this.zl_content.field119 = this.zl_content.startTime;
      this.zl_content.dbstartTime = this.zl_content.startTime;
    },
    zljei(e) {
      console.log(this.zl_content.startTime);
      if (this.zl_content.startTime == null) {
        this.$message({
          showClose: true,
          message: "请先选择开工日期",
          type: "warning",
        });
        this.zl_content.endTime = null;
      } else {
        this.zl_content.dbendTime = this.zl_content.endTime;
        console.log(
          "开始计算差值",
          this.sdateFormats(this.zl_content.startTime, this.zl_content.endTime),
          this.calculateDiffTime(
            this.zl_content.startTime,
            this.zl_content.endTime
          )
        );
        this.zl_content.dbqx = this.sdateFormats(
          this.zl_content.startTime,
          this.zl_content.endTime
        );
        this.zl_content.dbyue = this.calculateDiffTime(
          this.zl_content.startTime,
          this.zl_content.endTime
        );
      }
    },
    zlkaidb(e) {
      this.zl_content.field119 = this.zl_content.dbstartTime;
      this.zl_content.dbyue = this.calculateDiffTime(
        this.zl_content.dbstartTime,
        this.zl_content.dbendTime
      );
    },
    zljeidb(e) {
      this.zl_content.dbyue = this.calculateDiffTime(
        this.zl_content.dbstartTime,
        this.zl_content.dbendTime
      );
    },
    zlxuan(e) {
      if (e == 5) {
        this.zl_content.dbje =
          (parseFloat(this.yz_content.bhje) * this.zl_content.lyxuan5) / 100;
      }
      if (e == 3) {
        this.zl_content.dbje = parseFloat(this.zl_content.bhje) * 0.03;
      }
      if (e == 6) {
        this.zl_content.dbje = parseFloat(this.zl_content.bhje) * 0.05;
      }
      if (e == 9) {
        this.zl_content.dbje = parseFloat(this.zl_content.bhje) * 0.1;
      }
    },
    zlxuan5(e) {
      this.zl_content.dbje =
        (parseFloat(this.zl_content.bhje) * this.zl_content.lyxuan5) / 100;
      // this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5 /100
      this.zl_content.dbje = this.zl_content.dbje.toFixed(2);
    },
    zlfan(e) {
      if (e == 3) {
        this.zl_content.fdbbzj = parseFloat(this.zl_content.dbje) * 0.03;
        this.zl_content.fdbbzj = this.zl_content.fdbbzj.toFixed(2);
      }
      if (e == 5) {
        this.zl_content.fdbbzj =
          (parseFloat(this.zl_content.dbje) * this.zl_content.lyfan5) / 100;
        this.zl_content.fdbbzj = this.zl_content.fdbbzj.toFixed(2);
      }
      if (e == 6) {
        this.zl_content.fdbbzj = parseFloat(this.zl_content.dbje) * 0.05;
        this.zl_content.fdbbzj = this.zl_content.fdbbzj.toFixed(2);
      }
      if (e == 9) {
        this.zl_content.fdbbzj = parseFloat(this.zl_content.dbje) * 0.1;
        this.zl_content.fdbbzj = this.zl_content.fdbbzj.toFixed(2);
      }
    },
    zlfan5() {
      this.zl_content.fdbbzj =
        (parseFloat(this.zl_content.dbje) * this.zl_content.lyfan5) / 100;

      this.zl_content.fdbbzj = this.zl_content.fdbbzj.toFixed(2);
    },
    zlbao(e) {
      if (e == 3) {
        this.zl_content.bfje =
          parseFloat(this.zl_content.dbje) * 0.002 * this.zl_content.dbyue;
        if (this.zl_content.bfje < 2000) {
          this.zl_content.bfje = 2000;
        }
        this.zl_content.bfje = this.zl_content.bfje.toFixed(2);
      }
    },
    zlbaos5() {
      this.zl_content.bfje =
        ((parseFloat(this.zl.content.dbje) * this.zl_content.lybaos5) / 1000) *
        this.zl_content.dbyue;
      if (this.zl_content.bfje < 2000) {
        this.zl_content.bfje = 2000;
      }
      this.zl_content.bfje = this.zl_content.bfje.toFixed(2);
    },

    //农民工工资支付保函

    nmkai(e) {
      // console.log(123, this.sdateFormat(e), this.nm_content.startTime);
      this.nm_content.field119 = this.nm_content.gqStartTime;
      this.nm_content.bzqStartTime = this.nm_content.gqStartTime;
    },
    nmjei(e) {
      console.log(this.nm_content.gqStartTime, this.nm_content.gqEndTime);
      if (this.nm_content.gqStartTime == null) {
        this.$message({
          showClose: true,
          message: "请先选择开工日期",
          type: "warning",
        });
        this.nm_content.gqEndTime = null;
      } else {
        this.nm_content.bzqEndTime = this.nm_content.gqEndTime;
        this.nm_content.dbqx = this.sdateFormats(
          this.nm_content.gqStartTime,
          this.nm_content.gqEndTime
        );
        this.nm_content.dbyue = this.calculateDiffTime(
          this.nm_content.gqStartTime,
          this.nm_content.gqEndTime
        );
      }
    },
    nmkaidb(e) {
      this.nm_content.field119 = this.nm_content.bzqStartTime;
      this.nm_content.dbyue = this.calculateDiffTime(
        this.nm_content.bzqStartTime,
        this.nm_content.bzqEndTime
      );
    },
    nmjeidb(e) {
      this.nm_content.dbyue = this.calculateDiffTime(
        this.nm_content.bzqStartTime,
        this.nm_content.bzqEndTime
      );
    },
    nmxuan(e) {
      console.log(e);
      if (e == 5) {
        this.nm_content.dbje =
          (parseFloat(this.nm_content.bhje) * this.nm_content.lyxuan5) / 100;
        console.log("1担保金额(元)", this.nm_content.dbje);
        //   this.$set(this.nm_content, 'dbje', (parseFloat(this.nm_content.bhje) * this.nm_content.lyxuan5) / 100;
        //  console.log("1担保金额(元)",this.nm_content.dbje))
      }
      if (e == 3) {
        this.nm_content.dbje = parseFloat(this.nm_content.bhje) * 0.02;
        console.log("2担保金额(元)", this.nm_content.dbje);
      }
    },
    nmxuan5(e) {
      this.nm_content.dbje =
        (parseFloat(this.nm_content.bhje) * this.nm_content.lyxuan5) / 100;
      // this.ly_content.fdbbzj = parseFloat(this.ly_content.dbje) * this.ly_content.lyfan5 /100
      this.nm_content.dbje = this.nm_content.dbje.toFixed(2);
    },
    nmfan(e) {
      if (e == 3) {
        this.nm_content.fdbbzj = parseFloat(this.nm_content.dbje) * 0.03;
        this.nm_content.fdbbzj = this.nm_content.fdbbzj.toFixed(2);
      }
      if (e == 5) {
        this.nm_content.fdbbzj =
          (parseFloat(this.nm_content.dbje) * this.nm_content.lyfan5) / 100;
        this.nm_content.fdbbzj = this.nm_content.fdbbzj.toFixed(2);
      }
      if (e == 6) {
        this.nm_content.fdbbzj = parseFloat(this.nm_content.dbje) * 0.05;
        this.nm_content.fdbbzj = this.nm_content.fdbbzj.toFixed(2);
      }
      if (e == 9) {
        this.nm_content.fdbbzj = parseFloat(this.nm_content.dbje) * 0.1;
        this.nm_content.fdbbzj = this.nm_content.fdbbzj.toFixed(2);
      }
    },
    nmfan5() {
      this.nm_content.fdbbzj =
        (parseFloat(this.nm_content.dbje) * this.nm_content.lyfan5) / 100;

      this.nm_content.fdbbzj = this.nm_content.fdbbzj.toFixed(2);
    },
    nmbao(e) {
      if (e == 3) {
        this.nm_content.bfje =
          parseFloat(this.nm_content.dbje) * 0.0025 * this.nm_content.dbyue;
        if (this.nm_content.bfje < 2000) {
          this.nm_content.bfje = 2000;
        }
        this.nm_content.bfje = this.nm_content.bfje.toFixed(2);
      }
    },
    nmbaos5() {
      this.nm_content.bfje =
        ((parseFloat(this.nm_content.dbje) * this.nm_content.lybaos5) / 1000) *
        this.nm_content.dbyue;
      if (this.nm_content.bfje < 2000) {
        this.nm_content.bfje = 2000;
      }
      this.nm_content.bfje = this.nm_content.bfje.toFixed(2);
    },
    // ————————————————————————————————————————————————————————————————————————————————————————

    ahsdk() {
      console.log("失去焦点");
      this.content.bfje = Number(this.content.bzjje) * Number(this.content.fl);
      if (this.content.bfje <= 200) {
        this.content.bfje = 200;
      }
      console.log(this.content.bfje);
    },
    dateFormat(value) {
      let date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " "; //多种时间格式的拼接
    },
    sdateFormat(value) {
      let date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // let y = date.getFullYear();
      // console.log(date / (1000 * 3600 * 24),"计算时间的形式是什么")
      return date / (1000 * 3600 * 24); //多种时间格式的拼接
    },
    sdateFormats(begin, end) {
      var dateBegin = new Date(begin);
      var dateEnd = new Date(end);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      console.log("相差天数", dayDiff);
      return dayDiff;
    },
    tanchuang() {
      console.log(123);
      this.statis = true;
    },

    calculateDiffTime(e, i) {
      console.log(e, i);
      let endTime = i; //2021-08-16 17:51
      let startTime = e; //2032-08-16 17:51
      let flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
      let start = new Date(startTime);
      let end = new Date(endTime);
      let year = end.getFullYear() - start.getFullYear();
      let month = end.getMonth() - start.getMonth();
      let day = end.getDate() - start.getDate();
      if (month < 0) {
        year--;
        month = end.getMonth() + (12 - start.getMonth());
      }
      if (day < 0) {
        month--;
        let index = flag.findIndex((temp) => {
          return temp === start.getMonth() + 1;
        });
        let monthLength;
        if (index <= 6) {
          monthLength = 31;
        } else if (index > 6 && index <= 10) {
          monthLength = 30;
        } else {
          monthLength = 28;
        }
        day = end.getDate() + (monthLength - start.getDate());
      }
      var cion = 0;
      if (year !== 0) {
        cion = cion + 12 * year;
      }
      if (true) {
        cion = cion + month;
      }
      if (day >= 10) {
        cion = cion + 1;
      }
      this.result = `相差${year}年${month}月${day}天`;
      console.log(this.result, cion);
      return cion;
    },

    bidfroms() {
      let Base64 = require("js-base64").Base64; // 引入
      if (this.nametype == "履约保函") {
        var c = Base64.encode(JSON.stringify(this.ly_content));
      }
      if (this.nametype == "投标保函") {
        var c = Base64.encode(JSON.stringify(this.content));
      }
      if (this.nametype == "业主支付保函") {
        var c = Base64.encode(JSON.stringify(this.yz_content));
      }
      if (this.nametype == "农民工工资支付保函") {
        this.nm_content.endTime = this.nm_content.bzqEndTime;
        var c = Base64.encode(JSON.stringify(this.nm_content));
      }
      if (this.nametype == "质量保函") {
        var c = Base64.encode(JSON.stringify(this.zl_content));
      }
      //转json
      // var cion = {
      //   guarantee_apply_id: this.cion.id,
      //   content: c,
      //   user_id: sessionStorage.getItem("user_id")
      // };
      var cion = {
        apply_number: sessionStorage.getItem("apply_number"),
        content: c,
      };
      axios({
        url: "https://api.hnzyxsbh.com/handle/baohan/datasub",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...cion,
        },
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            if (this.nametype == "投标保函") {
              this.$router.push("/sAgreement");
            } else {
              // this.$router.push("/Agreement");
              this.$router.push("/fgreement");
            }
          } else {
            this.$message.error(res.data.mag);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch((err) => {
          console.log("失败", err.response.data);
          if (err.response.data.code == 401) {
            this.$notify.error({
              message: "请重新登录",
            });
            this.$router.push("/login");
            return;
          }
          this.$notify.error({
            message: err.response.data.msg,
          });
        });

      return;
      bidfrom(cion).then((err) => {
        console.log("已经提交", err.data.code);
        if (err.data.code == 1) {
          this.$message({
            message: "提交成功请等待审核",
            type: "success",
          });
          this.$router.push("/Agreement");
        } else {
          this.$message.error(err.data.mag);
        }
      });
    },
    Submittals() {
      this.$router.push("/Submittals");
    },
    Signature() {
      this.bidfroms();
    },
  },
};
</script>
<style>
.casxinda .el-collapse-item__header.is-active {
  border-bottom: 3px solid #f5f6fa;
}
.hong {
  color: #ff2f1f;
  border-bottom: 2px solid #000000 !important;
  background: #fff;
}

.usad .el-input__inner {
  border: 0px !important;
  background-color: #f5f6fa;
  height: 24px;
  padding: 0;
  /* width: 47px; */
  font-size: 18px;
  background: rgb(245, 246, 250);
  /* border-bottom: 2px solid; */
  text-decoration: underline;

  width: 40px;
}
.zil .el-date-editor .el-range-separator {
  display: none !important;
}
.zil .el-select .el-input .el-select__caret {
  display: none !important;
}

.zil .el-range-editor.el-input__inner {
  width: 20px !important;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3px 10px;
  padding: 0px;
  overflow: hidden;
  border: 0;
  background: #f5f6fa;
}
.zil .el-icon-date:before {
  content: "\E78E";
  font-size: 18px;
  color: black;
}
.el-icon-loading:before {
  content: "\E6CF";
  font-size: 20px;
}
.xmain .el-form-item__label {
  width: 180px !important;
  text-align: inherit;
}
.xmain .el-input {
  /* width: 80%; */
}
</style>
<style scoped >
.quan1 {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.quan2 {
  display: flex;
  margin-left: 20px;
  align-items: center;
}
.heng {
  text-decoration: underline;
}
.ly_tou {
  color: #ff2f1f;
  /* color: #f95c50; */
  font-size: 18px;
  font-weight: 500;
}
.ly_lan {
  color: #5181bd;
}
.ly_fen {
  display: flex;
  width: 66%;
  justify-content: space-between;
}
.main {
  /* position: absolute;
  width: 1600px;
  height: 600px;
  top: 200px;
  right: 0;
  bottom: 0;
  left: 0; */
  background-color: #f5f6fa;
  margin: auto;
  padding: 1.5% 5%;
}
.footer {
  /* position: absolute;
  bottom: 30px;
  left: 39%; */
  background-color: #f5f6fa;
  width: 100%;
  height: 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.qiu {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #409eff;
  color: #fff;
  font-size: 19px;
  margin-right: 10px;
  border-radius: 100%;
}
.qiutxt {
  font-size: 21px;
}
.hxxin {
  height: 24px;
  padding: 0;
  font-size: 18px;
  border-bottom: 2px solid;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/BidSecurity/bidFrom.vue